import { render } from "./DealTable.vue?vue&type=template&id=1b215aea&scoped=true"
import script from "./DealTable.vue?vue&type=script&lang=js"
export * from "./DealTable.vue?vue&type=script&lang=js"

import "./DealTable.vue?vue&type=style&index=0&id=1b215aea&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b215aea"]])

export default __exports__